import Axios from 'axios';
import { openReport } from '../../../utils/sessionGuard'; // セッション失効時は新タブを開かず現在の画面でログインへ
import React, { Fragment, useEffect, useMemo, useState } from 'react';
import config from '../../Config/key';
import {
  Table,
  // Divider,
  // Tag,
  Button,
  message,
  Typography,
  Select,
  // Modal,
  Space,
  Badge,
  Modal,
  Spin,
  Input,
  Alert,
} from 'antd';
// import { DeleteOutlined, DownOutlined } from '@ant-design/icons';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { userRole } from '../../Config/userRole';
import {
  TRADITIONAL_40010_TYPES,
  WEB_RESULT_40010_TYPES,
  isWeb360OpenFor,
} from '../../Config/surveyMeta';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { hidesTeamStatus } from '../../../utils/answerStatusView';
// テーブル強化 PJ Ph.3: メイン一覧テーブルに 列リサイズ + ソート + 省略
// （expandedRowRender 内のネストテーブルは従来の <Column> のまま）
import {
  PageContainer,
  useResizableColumns,
  ellipsisColumn,
  textSorter,
} from '../../common';
import {
  filterAccessibleSeasons,
  noAccessibleSeasonMessage,
} from '../../../utils/seasonFilter';
import {
  B_TYPE_RELATION4_CONFIRM,
  isBType360,
} from '../../../utils/survey360Relation';
// import { BsBoxArrowUpRight } from 'react-icons/bs';
// import { surveyCode } from '../../Config/surveyCode';
// import { surveyStatus } from '../../Config/surveyStatus';
const { confirm } = Modal;
const { Column, ColumnGroup } = Table;
const { Text } = Typography;
const { Option } = Select;
const { TextArea } = Input;
const survey_status_complete = 5;
let selSurveySeason = [];
let selSurveySeasonId = '';

// 検索用の正規化（氏名は空白を無視して部分一致させる）
const normalizeText = (s) =>
  String(s || '')
    .toLowerCase()
    .replace(/\s+/g, '');

// 検索キーワードに一致した「部分文字列だけ」を強調表示する（最初の1件のみ）。
// 一致が無ければ元の文字列をそのまま返す。
// ignoreSpaces=true（氏名）の場合は空白を無視して照合し、元の文字列上の位置へ復元する
// （例: 「芹沢 一宏」に「芹沢一宏」→ 内部の空白を含めて全体を強調）。
const highlightMatch = (value, keyword, ignoreSpaces) => {
  const src = String(value || '');
  if (!src || !keyword || !String(keyword).trim()) return src;

  let start = -1;
  let end = -1;

  if (ignoreSpaces) {
    // 正規化文字列の各文字が元文字列のどの位置かを保持する対応表
    const map = [];
    let normalized = '';
    for (let i = 0; i < src.length; i++) {
      const ch = src[i];
      if (/\s/.test(ch)) continue;
      map.push(i);
      normalized += ch.toLowerCase();
    }
    const nk = normalizeText(keyword);
    if (!nk) return src;
    const pos = normalized.indexOf(nk);
    if (pos < 0) return src;
    start = map[pos];
    end = map[pos + nk.length - 1] + 1; // 元文字列上の終了位置（exclusive）
  } else {
    const lowerKeyword = String(keyword).toLowerCase();
    const pos = src.toLowerCase().indexOf(lowerKeyword);
    if (pos < 0) return src;
    start = pos;
    end = pos + lowerKeyword.length;
  }

  return (
    <Fragment>
      {src.slice(0, start)}
      <mark className="search360-mark">{src.slice(start, end)}</mark>
      {src.slice(end)}
    </Fragment>
  );
};

const confirmRelation4Conversion = () =>
  new Promise((resolve) => {
    confirm({
      title: '関係の確認',
      content: B_TYPE_RELATION4_CONFIRM,
      okText: 'はい（部下・同僚として登録）',
      cancelText: 'キャンセル',
      onOk: () => resolve(true),
      onCancel: () => resolve(false),
    });
  });


// 協力者をユーザー一覧から探す。シーズン管理者の範囲（部署指定など。utils/answerStatusView.js）でサーバーが返さなかった人は
// 未回答の行として出す（以前は見つからないまま読みに行って画面が止まった）
const findMember = (users, id) =>
  (users || []).find((item) => item._id === id) || {
    _id: id,
    lastname: '（範囲外のユーザー）',
    name: '',
    survey_token: [],
  };
// 本人（チームの行）として出す人。一覧に無い人と、部署指定の範囲外で協力者としてだけ返された人（outside_dept）は出さない
const visibleHeroes = (heroes) => (heroes || []).filter((u) => u && !u.outside_dept);

function Status360Page(props) {
  const [tUsers, setTUsers] = useState([]); //グループフィルタリングされたユーザ一覧（全体）
  const [gUsers, setGUsers] = useState([]); //グループ・サーベイシーズンでフィルタリングされたユーザ一覧
  const [groups, setGroups] = useState([]); //グループ名とグループコード
  const [selGroupInfo, setSelGroupInfo] = useState([]); //グループ名とグループコード
  // const [surveySeason, setSurveySeason] = useState([]);
  // const [selSurveySeason, setSelSurveySeason] = useState([]);
  const [selGroupCode, setSelGroupCode] = useState(''); //選択されたグルプコード
  const [survey, setSurvey] = useState([]); //サーベイ名とサーベイコード
  // const [questionSet, setQuestionSet] = useState([]); //全ての設問セット
  // const [selSurveyId, setSelSurveyId] = useState(''); //選択したサーベイID
  // const [role360, setRole360] = useState(1); //選択した360度関係：１：本人、２：上司、３：部下・同僚
  // const [selSurveySeasonId, setSelSurveySeasonId] = useState(''); //選択したサーベイID
  // const [selSurveySeasonIdFilter, setSelSurveySeasonIdFilter] = useState(''); //選択したサーベイID
  const [userInfo, setUserInfo] = useState({});
  const [isModalVisible, setIsModalVisible] = useState(false);
  // 協力者を追加モーダル用の state（メンバー追加機能）
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [addHero, setAddHero] = useState(null); // 対象チームの本人(hero)レコード
  const [addRelationName, setAddRelationName] = useState('boss'); // boss/partner/sub
  const [addUserId, setAddUserId] = useState(undefined); // 追加する人の _id
  const [addLoading, setAddLoading] = useState(false);
  // 記述回答編集モーダル用の state（role 9 が 360 度の自由記述を是正・整形する）
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [editSaving, setEditSaving] = useState(false);
  const [editHeroName, setEditHeroName] = useState('');
  // [{ survey_token, name, relationLabel, items: [{ index, no, question, answer, original }] }]
  const [editCollaborators, setEditCollaborators] = useState([]);
  // 検索用の state（氏名・メールでチーム単位に絞り込み）
  const [searchKeyword, setSearchKeyword] = useState(''); //検索キーワード
  const [expandedRowKeys, setExpandedRowKeys] = useState([]); //展開中の行（制御型）
  const [currentPage, setCurrentPage] = useState(1); //現在のページ
  const [pageSize, setPageSize] = useState(100); //1ページの表示件数

  const usr = useSelector((state) => state.user);

  // 回答状況指定で 360度系が見られないシーズン管理者は、URL で直接開いてもトップへ戻す（メニューにも出さない。
  // サーバーも見られない回答状況を返さない。utils/answerStatusView.js・2026-10 追加パッチ）
  const history = useHistory();
  useEffect(() => {
    if (hidesTeamStatus(usr.userData)) history.push('/');
  }, [usr, history]);
  //9:管理者９が最高管理者
  // const userRole = [
  //   '停止中',
  //   '学習者',
  //   '管理者',
  //   'その他',
  //   'その他',
  //   'その他',
  //   'その他',
  //   'その他',
  //   'その他',
  //   '最高管理者',
  // ];

  //yyyy/mm/dd hh:mm
  const ymdhms = (tdate) => {
    let date = new Date(tdate);
    //console.log({ date });
    return (
      date.getFullYear() +
      '/' +
      ('0' + (date.getMonth() + 1)).slice(-2) +
      '/' +
      ('0' + date.getDate()).slice(-2) +
      ' ' +
      ('0' + date.getHours()).slice(-2) +
      ':' +
      ('0' + date.getMinutes()).slice(-2)
      // date.getMilliseconds()
    );
  };

  //yyyy/mm/dd
  const ymd = (tdate) => {
    let date = new Date(tdate);
    // console.log({ tdate });
    return (
      date.getFullYear() +
      '/' +
      ('0' + (date.getMonth() + 1)).slice(-2) +
      '/' +
      ('0' + date.getDate()).slice(-2)
      // date.getMilliseconds()
    );
  };

  const readDB = async () => {
    try {
      if (!usr.userData) return null;
      // console.log(usr.userData);
      setUserInfo(usr.userData);
      const [surveyInfo, groupInfo] = await Promise.all([
        Axios.get('/api/survey/'), //DBからサーベイ情報取得
        Axios.get('/api/group/360FS'), //DBからグループ情報取得
        // Axios.get('/api/surveySeason/'), //DBからシーズン情報取得
        // Axios.get(config.USER_SERVER), //全てのユーザの習得（管理者以外）
      ]);

      if (usr.userData.groupCode === 'RECRNT' && usr.userData.role === 2) {
        const nonGroup = groupInfo.data.groups.filter(
          (item) => item.group_code !== 'RECRNT'
        );
        setGroups(nonGroup);
      } else {
        setGroups(groupInfo.data.groups);
      }

      // setGroups(groupInfo.data.groups);
      setSurvey(surveyInfo.data.survey);
      // setSurveySeason(seasonInfo.data.surveySeason);
      setGUsers([]);
      setTUsers([]);
      if (!groups) throw 'グループ取得に失敗しました。';
      if (!survey) throw 'サーベイ取得に失敗しました。';
      // if (!seasonInfo) throw 'サーベイシーズン取得に失敗しました。';
      if (usr.userData.role === 3 || usr.userData.role === 7) {
        //企業管理者 (role 3) / シーズン指定管理者 (role 7)
        // onChangeGroup(usr.userData.groupCode);
        let sgi = groupInfo.data.groups.find(
          (item) => item.group_code === usr.userData.groupCode
        );

        // console.log({ sgi });
        setSelGroupCode(usr.userData.groupCode);
        // 自社に 360度／FS のサーベイシーズンが無い場合（/api/group/360FS に含まれない）は sgi が undefined に
        // なるため空オブジェクトにし、画面には案内を出す（従来はここで undefined.survey_season を参照してクラッシュ）
        setSelGroupInfo(sgi || {});
        // setGroupSurveySeasonInfo(
        //   sgi.survey_season.filter((item) => item.survey_code === '40010')
        // );
        if (sgi) filterDatasource(usr.userData.groupCode);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    readDB();
    // console.log({ Users });
  }, [usr]);

  // 検索インデックスと一致判定（派生のみ。結果は保存しない）
  // 本人(hero)が一致、またはチーム内の協力者が一致したチームだけを一覧に残す。
  // ※ selSurveySeason はモジュール変数のため deps に入れられないが、
  //   シーズン変更時は必ず setGUsers が伴うため gUsers を代理 deps として使う。
  const {
    filteredUsers,
    heroMatchIds,
    memberMatchIdsByTeam,
    autoExpandKeys,
    teamCount,
    personCount,
  } = useMemo(() => {
    const kw = searchKeyword.trim();
    if (!kw) {
      return {
        filteredUsers: gUsers,
        heroMatchIds: new Set(),
        memberMatchIdsByTeam: new Map(),
        autoExpandKeys: [],
        teamCount: 0,
        personCount: 0,
      };
    }

    const normalizedKeyword = normalizeText(kw);
    const lowerKeyword = kw.toLowerCase();
    //氏名は空白を無視した部分一致、メールは小文字化した部分一致
    const isMatch = (fullname, email) =>
      (!!normalizedKeyword &&
        normalizeText(fullname).includes(normalizedKeyword)) ||
      String(email || '')
        .toLowerCase()
        .includes(lowerKeyword);

    const relations = (selSurveySeason && selSurveySeason.relation_360) || [];
    const heroIds = new Set();
    const memberMap = new Map();
    const expandKeys = [];
    const matchedUsers = [];
    let persons = 0;

    (gUsers || []).forEach((hero) => {
      if (!hero || !hero._id) return;
      const team = relations.find((item) => item.user_id === hero._id);
      const memberHits = new Set();
      if (team) {
        ['boss', 'partner', 'sub'].forEach((relationName) => {
          (team[relationName] || []).forEach((memberId) => {
            const memberInfo = (tUsers || []).find(
              (item) => item._id === memberId
            );
            // ガード: グループ一覧に存在しない ID は対象外
            if (!memberInfo) return;
            const memberFullname =
              (memberInfo.lastname || '') + ' ' + (memberInfo.name || '');
            if (isMatch(memberFullname, memberInfo.email)) {
              memberHits.add(memberInfo._id);
            }
          });
        });
      }

      const heroHit = isMatch(
        hero.fullName || (hero.lastname || '') + ' ' + (hero.name || ''),
        hero.email
      );
      if (heroHit) {
        heroIds.add(hero._id);
        persons += 1;
      }
      if (memberHits.size > 0) {
        memberMap.set(hero._id, memberHits);
        expandKeys.push(hero._id);
        persons += memberHits.size; //同じ人が複数チームに居る場合は出現回数で数える
      }
      if (heroHit || memberHits.size > 0) {
        matchedUsers.push(hero);
      }
    });

    return {
      filteredUsers: matchedUsers,
      heroMatchIds: heroIds,
      memberMatchIdsByTeam: memberMap,
      autoExpandKeys: expandKeys,
      teamCount: matchedUsers.length,
      personCount: persons,
    };
  }, [gUsers, tUsers, searchKeyword]);

  // 検索一致チームの自動展開（クリア時は展開状態を初期化）
  useEffect(() => {
    const kw = searchKeyword.trim();
    if (!kw) {
      setExpandedRowKeys([]);
      return;
    }
    setExpandedRowKeys((prev) =>
      Array.from(new Set([...prev, ...autoExpandKeys]))
    );
  }, [searchKeyword, gUsers]); // eslint-disable-line react-hooks/exhaustive-deps

  // 検索キーワードの変更（ページ番号を先頭に戻して空表示を防ぐ）
  const onChangeSearchKeyword = (e) => {
    setSearchKeyword(e.target.value);
    setCurrentPage(1);
  };

  // 検索条件をリセット（企業・シーズンの切り替え時に使用）
  const resetSearchState = () => {
    setSearchKeyword('');
    setExpandedRowKeys([]);
    setCurrentPage(1);
  };

  //リストフィルタリング
  const filterDatasource = async (groupCode) => {
    // setGUsers(
    //   Users.filter(function (user) {
    //     return user.group_code === groupCode;
    //   })
    // );
    message.loading({
      content: '読み込み中...',
      key: 'updateable',
      duration: 20,
    });
    const res = await Axios.get(`${config.USER_SERVER}/group/${groupCode}`);
    // console.log({ res });
    let userData = res.data.users;
    userData.map((user) => {
      user.fullName = user.lastname + ' ' + user.name;
      user.roleText = userRole[user.role];
      if (user.survey_token.length === 0) {
        user.takeTokenCnt = 0;
        user.usedTokenCnt = 0;
        user.surveyProgress = 0;
      } else {
        user.takeTokenCnt = user.survey_token.length;
        user.usedTokenCnt = user.survey_token.filter(function (tokenInfo) {
          return tokenInfo.survey_status === 5; //実施済み：5
        }).length;
        user.surveyProgress = (user.usedTokenCnt / user.takeTokenCnt) * 100;
      }
      return user;
    });
    setGUsers([]); //SurveySeason選択するまでデータ表示をしない
    setTUsers(userData); //選択したグループの全員
    // console.log({ userData });
    message.success({
      content: '読み込み完了！',
      key: 'updateable',
      duration: 2,
    });
  };

  //グループを変更した場合
  const onChangeGroup = (value) => {
    // console.log(`selected ${value}`);
    setSelGroupCode(value);
    setGUsers([]); //グループ変更時にテーブルデータを即時クリア
    resetSearchState(); //検索条件・展開状態・ページも初期化
    selSurveySeason = [];
    selSurveySeasonId = '';
    filterDatasource(value); //リストフィルタリング
    const selGroup = groups.find((item) => item.group_code === value);
    // console.log({ selGroup });
    setSelGroupInfo(selGroup);
    // setQuestionSet([]);
    // setSelSurveyId('');
    // setRole360('');
    // setSelSurveySeasonInfo([]);
  };

  //サーベイシーズンを変更した場合（絞り込み）
  //360度診断のみが選択される
  //valueはSurveySeasonのid
  // console.log(`selected ${value}`);
  const onChangeSeasonFilter = (seasonId) => {
    // クリア（×）で seasonId が undefined の場合はシーズン選択を解除し、
    // シーズン未選択の初期状態（一覧非表示）に戻す。
    // 従来はページ更新／企業の再選択が必要だった操作をボタン化したもの。
    if (!seasonId) {
      selSurveySeasonId = '';
      selSurveySeason = [];
      setGUsers([]);
      resetSearchState(); //検索条件・展開状態・ページも初期化
      return;
    }
    resetSearchState(); //検索条件・展開状態・ページも初期化
    selSurveySeasonId = seasonId;
    selSurveySeason = selGroupInfo.survey_season.find(
      (item) => item._id === seasonId
    );
    // selSurveySeason = selSeasonInfo;
    const gUserArr = []; //本人たちの情報
    // console.log({ tUsers });
    selSurveySeason.relation_360.map((element) => {
      gUserArr.push(tUsers.find((item) => item._id === element.user_id)); //本人のみをFilter
    });
    // console.log({ gUserArr });
    // console.log({ selSurveySeason });
    setGUsers(computCnt(visibleHeroes(gUserArr), seasonId));
  };

  //本人たちの情報とシーズンIDを利用して「本人」行の情報を構成
  // ※ users は協力者の照合に使うユーザー配列。既定は state の tUsers だが、
  //   協力者追加直後など state 更新が反映される前に最新配列で再計算したい場合に上書きできる
  const computCnt = (gUserArr, seasonId, users = tUsers) => {
    // let seasonTokenInfo = {};
    gUserArr.map((user) => {
      let doneCnt = 0;
      let totalCnt = 0;
      let heroCnt = 0;
      let bossCnt = 0;
      let partnerCnt = 0;
      let subCnt = 0;
      if (user.survey_token.length === 0) {
        user.takeTokenCnt = 0;
        user.usedTokenCnt = 0;
        user.status = false;
      } else {
        // console.log(user.survey_token);
        // console.log({ seasonId });

        let sortedToken = user.survey_token.sort(function (a, b) {
          return a.updatedAt > b.updatedAt ? -1 : 1; //オブジェクトの昇順ソート
        });
        // console.log({ result });

        //選択したサーベイセッション＋自分が本人のトークン情報を１個探す
        let seasonTokenInfo = user.survey_token.find(
          (tokenInfo) =>
            tokenInfo.survey_season_id === seasonId && tokenInfo.relation === 1
        );
        //選択してないサーベイシーズン＋自分が本人＋360サーベイ＋全員が受検済み+過去のサーベイであること+同じQuestionSet
        //前回との比較対象の「あり」・「なし」を決める
        let lastSeasonTokenInfo = sortedToken.find(
          (tokenInfo) =>
            tokenInfo.survey_status === 5 &&
            tokenInfo.relation === 1 &&
            tokenInfo.survey_code === '40010' &&
            tokenInfo.survey_season_id != seasonId &&
            ymd(tokenInfo.updatedAt) < ymd(seasonTokenInfo.updatedAt) &&
            tokenInfo.question_set_id === seasonTokenInfo.question_set_id
        );
        //残的的にトークンを選定
        //これから前回の回答が全員回答したのかを検証
        let lastSeason = false;
        if (lastSeasonTokenInfo) {
          const lastSurveySeason = selGroupInfo.survey_season.find(
            (item) => item._id === lastSeasonTokenInfo.survey_season_id
          );
          // console.log({ lastSurveySeason });
          // console.log({ lastSeasonTokenInfo });
          lastSeason = isLastSeasonComplete(user, lastSurveySeason);
        }

        if (seasonTokenInfo.survey_status === survey_status_complete) {
          user.status = true;
          user.testDate = ymdhms(seasonTokenInfo.updatedAt);
          totalCnt++;
          doneCnt++;
          heroCnt++;

          user.lastSeason = lastSeason;
          if (lastSeason) {
            user.lastSeasonTokenInfo = lastSeasonTokenInfo;
            user.lastSurveySeason = selGroupInfo.survey_season.find(
              (item) => item._id === lastSeasonTokenInfo.survey_season_id
            );
          }
        } else {
          user.status = false;
          user.testDate = '-';
          totalCnt++;
        }
        // user.status = seasonTokenInfo.survey_status === 5 > 0 ? true : false;
      }
      // const u = Object.assign({}, JSON.parse(JSON.stringify(user)));
      // console.log({ u });
      // const data = makeTeam(u); //本人1名の情報を送ってチーム情報を持ってくる
      // console.log(data);
      // const totlaCnt = data.length + 1;
      // const doneCnt =
      //   data.filter((item) => item.status === true).length +
      //   (user.status ? 1 : 0);
      // user.totalStatus = totlaCnt === doneCnt;
      // user.cnt = `${doneCnt} / ${totlaCnt}`;
      const team = selSurveySeason.relation_360.find(
        (item) => item.user_id === user._id
      );

      let seasonTokenInfo = {};
      // console.log({ team });
      for (let i = 0; i < team.boss.length; i++) {
        const bossId = team.boss[i];
        const bossInfo = findMember(users, bossId);
        if (bossInfo.survey_token.length === 0) {
          bossInfo.status = false;
          seasonTokenInfo = {};
        } else {
          seasonTokenInfo = bossInfo.survey_token.find(
            (tokenInfo) =>
              tokenInfo.survey_season_id === selSurveySeasonId &&
              tokenInfo.hero_id === user._id
          );
          // console.log({ seasonTokenInfo });
          if (seasonTokenInfo && seasonTokenInfo.survey_status === 5) {
            doneCnt++;
            totalCnt++;
            bossCnt++;
          } else {
            totalCnt++;
          }
        }
      }
      for (let i = 0; i < team.partner.length; i++) {
        const partnerId = team.partner[i];
        const partnerInfo = findMember(users, partnerId);
        if (partnerInfo.survey_token.length === 0) {
          partnerInfo.status = false;
          seasonTokenInfo = {};
        } else {
          seasonTokenInfo = partnerInfo.survey_token.find(
            (tokenInfo) =>
              tokenInfo.survey_season_id === selSurveySeasonId &&
              tokenInfo.hero_id === user._id
          );
          if (seasonTokenInfo && seasonTokenInfo.survey_status === 5) {
            doneCnt++;
            totalCnt++;
            partnerCnt++;
          } else {
            totalCnt++;
          }
        }
      }
      for (let i = 0; i < team.sub.length; i++) {
        const subId = team.sub[i];
        const subInfo = findMember(users, subId);
        // console.log({ tUsers });
        // console.log({ subInfo });
        if (subInfo.survey_token.length === 0) {
          subInfo.status = false;
          seasonTokenInfo = {};
        } else {
          seasonTokenInfo = subInfo.survey_token.find(
            (tokenInfo) =>
              tokenInfo.survey_season_id === selSurveySeasonId &&
              tokenInfo.hero_id === user._id
          );
          // console.log({ selSurveySeasonId });
          // console.log(user._id);
          if (seasonTokenInfo && seasonTokenInfo.survey_status === 5) {
            doneCnt++;
            totalCnt++;
            subCnt++;
          } else {
            totalCnt++;
          }
        }
      }
      // console.log({ seasonTokenInfo });
      user.totalStatus = totalCnt === doneCnt;
      // ★暫定（2026-10-27）: 従来型の判定を「上司＋（同僚または部下）」に変える件は Web 結果の本格リリース時に合わせる。
      // それまでは従来どおり「上司＋同僚」。
      const cutOver =
        seasonTokenInfo.survey_code === '60020' ||
        selSurveySeason.question_set[0].type_360 === '3x3x5' ||
        selSurveySeason.question_set[0].type_360 === 'gates' ||
        selSurveySeason.question_set[0].type_360 === 'initiative' ||
        selSurveySeason.question_set[0].type_360 === 'eleader'
          ? heroCnt && (bossCnt || partnerCnt || subCnt)
            ? '🌞'
            : '🌨️'
          : heroCnt && bossCnt && partnerCnt
          ? '🌞'
          : '🌨️';
      // console.log(seasonTokenInfo, heroCnt, bossCnt, cutOver);
      user.cnt = `${doneCnt} / ${totalCnt} ： ${cutOver}`;
      return user;
    });
    // console.log(gUserArr);

    return gUserArr;
  };

  const isLastSeasonComplete = (user, lastSurveySeason) => {
    let doneCnt = 0;
    let totalCnt = 0;
    // let heroCnt = 1;
    let bossCnt = 0;
    let partnerCnt = 0;
    const team = lastSurveySeason.relation_360.find(
      (item) => item.user_id === user._id
    );

    let seasonTokenInfo = {};
    // console.log({ team });
    for (let i = 0; i < team.boss.length; i++) {
      const bossId = team.boss[i];
      const bossInfo = findMember(tUsers, bossId);
      if (bossInfo.survey_token.length === 0) {
        bossInfo.status = false;
        seasonTokenInfo = {};
      } else {
        seasonTokenInfo = bossInfo.survey_token.find(
          (tokenInfo) =>
            tokenInfo.survey_season_id === lastSurveySeason._id &&
            tokenInfo.hero_id === user._id
        ) || {};
        // console.log({ seasonTokenInfo });
        if (seasonTokenInfo.survey_status === 5) {
          doneCnt++;
          totalCnt++;
          bossCnt++;
        } else {
          totalCnt++;
        }
      }
    }
    for (let i = 0; i < team.partner.length; i++) {
      const partnerId = team.partner[i];
      const partnerInfo = findMember(tUsers, partnerId);
      if (partnerInfo.survey_token.length === 0) {
        partnerInfo.status = false;
        seasonTokenInfo = {};
      } else {
        seasonTokenInfo = partnerInfo.survey_token.find(
          (tokenInfo) =>
            tokenInfo.survey_season_id === lastSurveySeason._id &&
            tokenInfo.hero_id === user._id
        ) || {};
        // console.log({ seasonTokenInfo });
        if (seasonTokenInfo.survey_status === 5) {
          doneCnt++;
          totalCnt++;
          partnerCnt++;
        } else {
          totalCnt++;
        }
      }
    }
    // console.log({ doneCnt });
    // console.log({ totalCnt });
    return totalCnt === doneCnt && totalCnt > 0 ? true : false;
  };

  const makeTeam = (user) => {
    // console.log({ user });
    //チームの基本情報を獲得
    const team = (selSurveySeason.relation_360 || []).find(
      (item) => item.user_id === user._id
    );
    // ガード: チームが見つからない場合（削除直後の stale 呼び出し等）は空配列を返す
    if (!team) return [];
    // console.log({ team });
    const data = [];
    let seasonTokenInfo = {};
    // console.log({ selSurveySeasonId });
    team.boss.map((bossId, i) => {
      const bossInfo = findMember(tUsers, bossId);
      if (bossInfo.survey_token.length === 0) {
        bossInfo.status = false;
        seasonTokenInfo = {};
      } else {
        seasonTokenInfo = bossInfo.survey_token.find(
          (tokenInfo) =>
            tokenInfo.survey_season_id === selSurveySeasonId &&
            tokenInfo.hero_id === user._id
        ) || {};
        // console.log({ seasonTokenInfo });
        if (seasonTokenInfo.survey_status === 5) {
          bossInfo.status = true;
          bossInfo.testDate = ymdhms(seasonTokenInfo.updatedAt);
        } else {
          bossInfo.status = false;
          bossInfo.testDate = '-';
        }
      }
      // console.log({ bossInfo });
      data.push({
        key: i.toString(),
        userId: bossInfo._id,
        teamId: team._id,
        relation: '上司',
        relationName: 'boss',
        fullname: bossInfo.lastname + ' ' + bossInfo.name,
        email: bossInfo.email,
        department: bossInfo.department,
        status: bossInfo.status,
        testDate: bossInfo.testDate,
        tokenId: seasonTokenInfo._id,
      });
    });

    team.partner.map((partnerId, i) => {
      const partnerInfo = findMember(tUsers, partnerId);
      if (partnerInfo.survey_token.length === 0) {
        partnerInfo.status = false;
        seasonTokenInfo = {};
      } else {
        seasonTokenInfo = partnerInfo.survey_token.find(
          (tokenInfo) =>
            tokenInfo.survey_season_id === selSurveySeasonId &&
            tokenInfo.hero_id === user._id
        ) || {};
        if (seasonTokenInfo.survey_status === 5) {
          partnerInfo.status = true;
          partnerInfo.testDate = ymdhms(seasonTokenInfo.updatedAt);
        } else {
          partnerInfo.status = false;
          partnerInfo.testDate = '-';
        }
      }
      data.push({
        key: (i + 10).toString(),
        userId: partnerInfo._id,
        teamId: team._id,
        relation: '同僚',
        relationName: 'partner',
        fullname: partnerInfo.lastname + ' ' + partnerInfo.name,
        email: partnerInfo.email,
        department: partnerInfo.department,
        status: partnerInfo.status,
        testDate: partnerInfo.testDate,
        tokenId: seasonTokenInfo._id,
      });
    });
    team.sub.map((subId, i) => {
      const subInfo = findMember(tUsers, subId);
      if (subInfo.survey_token.length === 0) {
        subInfo.status = false;
        seasonTokenInfo = {};
      } else {
        seasonTokenInfo = subInfo.survey_token.find(
          (tokenInfo) =>
            tokenInfo.survey_season_id === selSurveySeasonId &&
            tokenInfo.hero_id === user._id
        ) || {};
        if (seasonTokenInfo.survey_status === 5) {
          subInfo.status = true;
          subInfo.testDate = ymdhms(seasonTokenInfo.updatedAt);
        } else {
          subInfo.status = false;
          subInfo.testDate = '-';
        }
      }
      data.push({
        key: (i + 20).toString(),
        userId: subInfo._id,
        teamId: team._id,
        relation: '部下',
        relationName: 'sub',
        fullname: subInfo.lastname + ' ' + subInfo.name,
        email: subInfo.email,
        department: subInfo.department,
        status: subInfo.status,
        testDate: subInfo.testDate,
        tokenId: seasonTokenInfo._id,
      });
    });

    // 本人(hero)情報を全レコードに付与（C3 強制削除モーダルで echo 入力に使用）
    const heroId = user._id;
    const heroFullname = (user.lastname || '') + (user.name || '');
    return data.map((d) => ({ ...d, heroId, heroFullname }));
  };

  const expandedRowRender = (user) => {
    //サブテーブルのタグを返却する関数
    if (selSurveySeason.length === 0) return null;

    // ガード: 本人(user) のチームが既に削除されている場合は何も描画しない
    // （Antd Table の expanded 状態が stale な _id を保持しており、
    //  setGUsers で本人行を消した直後に本コールバックがもう1回呼ばれる
    //  ケースで makeTeam 内 TypeError を防ぐ）
    if (!user || !user._id) return null;
    const teamExists = (selSurveySeason.relation_360 || []).some(
      (t) => t.user_id === user._id
    );
    if (!teamExists) return null;

    // このチームで検索に一致した協力者（ハイライト対象）
    const hitSet = memberMatchIdsByTeam.get(user._id) || new Set();
    const keyword = searchKeyword.trim();
    //検索に一致した協力者の行のみ、検索語に当たった部分文字列だけをハイライト
    const highlightName = (record, value) =>
      keyword && hitSet.has(record.userId)
        ? highlightMatch(value, keyword, true)
        : value;
    const highlightEmail = (record, value) =>
      keyword && hitSet.has(record.userId)
        ? highlightMatch(value, keyword, false)
        : value;

    let columns = [
      {
        title: '関係',
        dataIndex: 'relation',
        key: 'relation',
      },
      {
        title: '名前',
        dataIndex: 'fullname',
        key: 'fullname',
        render: (value, record) => highlightName(record, value),
      },
      {
        title: 'メール',
        dataIndex: 'email',
        key: 'email',
        render: (value, record) => highlightEmail(record, value),
      },
      {
        title: '部署',
        dataIndex: 'department',
        key: 'department',
      },
      {
        title: '回答状態',
        key: 'status',
        render: (record) =>
          record.status ? (
            <span>
              <Badge status="success" />
              回答済
            </span>
          ) : (
            <span>
              <Badge status="error" />
              未回答
            </span>
          ),
      },
      {
        title: '回答日',
        dataIndex: 'testDate',
        key: 'testDate',
      },
    ];
    if (userInfo.role === 9) {
      columns.push({
        title: 'メンバー調整',
        key: 'key',
        render: (record) =>
          !record.status ? (
            // 未回答: 既存ロジック（C2） — 削除関連のため赤（danger）に統一（修正依頼2 item 1）
            <Button
              danger
              size="small"
              onClick={(e) => showConfirm(record, e)}
            >
              メンバーから外す
            </Button>
          ) : (
            // 回答済み: 強制削除（C3） — バックアップメール送信後に削除
            <Button
              danger
              size="small"
              onClick={(e) => showForceConfirm(record, e)}
            >
              データごと削除
            </Button>
          ),
      });
    }
    const data = makeTeam(user);

    return (
      <Fragment>
        <Table
          columns={columns}
          dataSource={data}
          pagination={false}
          bordered
          rowClassName={(record) =>
            (record.status ? 'sub360-ok' : 'sub360') +
            (hitSet.has(record.userId) ? ' search360-hit' : '')
          }
        />
        {userInfo.role === 9 && (
          <div style={{ marginTop: 'var(--space-2)' }}>
            <Button
              type="dashed"
              icon={<PlusOutlined />}
              size="small"
              onClick={() => {
                setAddHero(user);
                setAddRelationName('boss');
                setAddUserId(undefined);
                setAddModalOpen(true);
              }}
            >
              協力者を追加
            </Button>
          </div>
        )}
      </Fragment>
    );
  };

  // 追加モーダルの候補者を算出（この本人(hero) + このチームの既存協力者を除外）
  // ※ 同じ企業の中から氏名・メールで検索。他チームの本人は協力者として追加可能（Q1: この팀の本人のみ除外）
  const getAddCandidates = () => {
    if (!addHero) return [];
    const team = (selSurveySeason.relation_360 || []).find(
      (r) => r.user_id === addHero._id
    );
    const exclude = new Set([
      String(addHero._id),
      ...(((team && team.boss) || []).map(String)),
      ...(((team && team.partner) || []).map(String)),
      ...(((team && team.sub) || []).map(String)),
    ]);
    return (tUsers || [])
      .filter((u) => !exclude.has(String(u._id)))
      .map((u) => ({
        value: u._id,
        label: `${u.lastname || ''} ${u.name || ''}（${u.email || ''}）`,
      }));
  };

  // 協力者を追加（addmember API 呼び出し + 成功時ローカル状態更新）
  const addMemberHandler = async () => {
    if (!addUserId) {
      message.error({
        content: '追加する人を選択してください。',
        key: 'addmember',
        duration: 2,
      });
      return;
    }
    const team = (selSurveySeason.relation_360 || []).find(
      (r) => r.user_id === addHero._id
    );
    if (!team) {
      message.error({
        content: 'チーム情報が取得できません。',
        key: 'addmember',
        duration: 2,
      });
      return;
    }
    const relationNumMap = { boss: 2, partner: 3, sub: 4 };
    // 協力者用（sub_type '5'）の設問セット _id を採用（DB 確認済み。sub_type は文字列）
    const qset = (selSurveySeason.question_set || []).find(
      (q) => String(q.sub_type) === '5'
    );
    if (!qset) {
      message.error({
        content: '協力者用の設問セットが見つかりません。',
        key: 'addmember',
        duration: 3,
      });
      return;
    }
    let effectiveRelationName = addRelationName;
    if (addRelationName === 'sub' && isBType360(qset.type_360)) {
      const confirmed = await confirmRelation4Conversion();
      if (!confirmed) return;
      effectiveRelationName = 'partner';
    }
    // 既存トークンと同形式（lastname + 空白 + name）
    const heroName = `${addHero.lastname || ''} ${addHero.name || ''}`.trim();
    const info = {
      teamId: team._id,
      userId: addUserId,
      relationName: effectiveRelationName,
      relation: relationNumMap[effectiveRelationName],
      seasonId: selSurveySeasonId,
      groupCode: selGroupCode,
      heroId: addHero._id,
      heroName,
      surveyId: selSurveySeason.survey_id,
      surveyCode: selSurveySeason.survey_code,
      questionSetId: qset._id,
      executorToken: localStorage.getItem('w_auth'),
    };
    try {
      setAddLoading(true);
      const res = await Axios.patch('/api/relation360/addmember', info);
      if (res.data && res.data.success) {
        message.success({
          content: '協力者を追加しました。',
          key: 'addmember',
          duration: 2,
        });
        // サーバー応答 result = [relation, season, group, token, user]。token = 発行済みトークン
        const newToken = res.data.result && res.data.result[3];
        // 1) selSurveySeason.relation_360 の該当チームの [relationName] に userId を追加
        selSurveySeason.relation_360 = (selSurveySeason.relation_360 || []).map(
          (rel) => {
            if (rel._id === team._id) {
              const arr = Array.isArray(rel[effectiveRelationName])
                ? rel[effectiveRelationName]
                : [];
              return {
                ...rel,
                [effectiveRelationName]: [...arr, addUserId],
              };
            }
            return rel;
          }
        );
        // 2) tUsers の対象ユーザーの survey_token に新トークンを push
        const updatedTUsers = (tUsers || []).map((u) => {
          if (u._id === addUserId) {
            const tokens = Array.isArray(u.survey_token) ? u.survey_token : [];
            return {
              ...u,
              survey_token: newToken ? [...tokens, newToken] : tokens,
            };
          }
          return u;
        });
        setTUsers(updatedTUsers);
        // 3) gUsers を再計算（showConfirm と同パターン）
        const gUserArr = [];
        selSurveySeason.relation_360.forEach((element) => {
          const found = updatedTUsers.find((item) => item._id === element.user_id);
          if (found) gUserArr.push(found);
        });
        // 追加直後は tUsers(state) がまだ更新前のため、最新の updatedTUsers を渡して再計算
        setGUsers(computCnt(visibleHeroes(gUserArr), selSurveySeasonId, updatedTUsers));
        setAddModalOpen(false);
      } else {
        message.error({
          content: (res.data && res.data.error) || '協力者の追加に失敗しました。',
          key: 'addmember',
          duration: 4,
        });
      }
    } catch (error) {
      console.log(error);
      message.error({
        content:
          (error.response && error.response.data && error.response.data.error) ||
          '協力者の追加に失敗しました。',
        key: 'addmember',
        duration: 4,
      });
    } finally {
      setAddLoading(false);
    }
  };

  // //チケット削除
  // const surveyResultHandler = async (tokenInfo, e) => {
  //   // console.log(tokenInfo);

  //   try {
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const showConfirm = async (userInfo, e) => {
    // console.log(userInfo);
    confirm({
      title: 'メンバーを外します',
      content:
        '診断メンバーを外しますと発行済みの診断チケットも一緒にキャンセルされます',
      async onOk() {
        const result = await memberDeleteHandler(userInfo, e);
        if (result) {
          message.success({
            content: 'メンバーを外しました。',
            key: 'member',
            duration: 2,
          });
          // relation_360からメンバー除外（expandedRowRender用）
          selSurveySeason.relation_360 = selSurveySeason.relation_360.map(
            (rel) => {
              if (rel._id === userInfo.teamId) {
                return {
                  ...rel,
                  [userInfo.relationName]: rel[userInfo.relationName].filter(
                    (id) => id !== userInfo.userId
                  ),
                };
              }
              return rel;
            }
          );
          // tUsersのトークン更新（ローカル変数で保持）
          // サーバー側 delmember の削除条件 (survey_season_id, hero_id) と同一基準で除去する
          // （tokenId 基準だと stale な行＝tokenId 未取得時に取り残しが出るため）
          const updatedTUsers = tUsers.map((u) => {
            if (u._id === userInfo.userId) {
              return {
                ...u,
                survey_token: u.survey_token.filter(
                  (t) =>
                    !(
                      t.survey_season_id === selSurveySeasonId &&
                      t.hero_id === userInfo.heroId
                    )
                ),
              };
            }
            return u;
          });
          setTUsers(updatedTUsers);
          // gUsersを再計算
          const gUserArr = [];
          selSurveySeason.relation_360.forEach((element) => {
            const found = updatedTUsers.find(
              (item) => item._id === element.user_id
            );
            if (found) gUserArr.push(found);
          });
          setGUsers(computCnt(visibleHeroes(gUserArr), selSurveySeasonId));
        } else {
          message.error({
            content: 'メンバー調整に失敗しました。',
            key: 'member',
            duration: 2,
          });
          throw new Error('メンバー調整に失敗しました。');
        }
      },
      async onCancel() {
        message.success({
          content: 'メンバー調整を取り消しました。',
          key: 'member',
          duration: 2,
        });
      },
    });
  };
  //チケット削除
  const memberDeleteHandler = async (userInfo, e) => {
    // console.log(userInfo);

    try {
      const info = {
        teamId: userInfo.teamId,
        userId: userInfo.userId,
        relationName: userInfo.relationName,
        seasonId: selSurveySeasonId,
        groupCode: selGroupCode,
        tokenId: userInfo.tokenId,
      };
      // console.log({ info });
      const res = await Axios.patch('/api/relation360/delmember', info);
      if (res.data.success) {
        // console.log(res.data);
        return res;
      } else {
        message.error({
          content: res.data.error || 'メンバー削除に失敗しました。',
          key: 'csvupload',
          duration: 4,
        });
        throw new Error('メンバー削除に失敗しました。');
      }
    } catch (error) {
      console.log(error);
      // サーバーが返した具体的なエラー（回答済みトークン存在時の 409 等）を表示する
      const serverError =
        error.response && error.response.data && error.response.data.error;
      if (serverError) {
        message.error({
          content: serverError,
          key: 'csvupload',
          duration: 4,
        });
      }
    }
  };

  //===========================================
  // 回答済み協力者 + 回答データの強制削除 (C3)
  // 計画書 Ph.2 — 本人氏名 echo 入力 + バックアップメール送信成功後に削除
  //===========================================
  const showForceConfirm = async (userInfo, e) => {
    const heroFullname = (userInfo.heroFullname || '').trim();
    // モーダル内 Input の値は closure 変数で捕捉（Modal.confirm 関数パターン対応）
    let inputEcho = '';

    Modal.confirm({
      title: '回答済みデータを完全削除します',
      width: 580,
      icon: null,
      content: (
        <div>
          <Alert
            type="warning"
            showIcon
            message="この操作は取り消せません"
            description={
              <div>
                <p>
                  協力者{' '}
                  <b>
                    {userInfo.fullname}（{userInfo.email}）
                  </b>{' '}
                  の回答データを一括削除します。
                </p>
                <p>
                  削除後は対象本人「<b>{heroFullname}</b>
                  」の 360 度フィードバック PDF レポートの集計内容が
                  変わるため、再生成が必要になります。再生成までの間、
                  既存の PDF は「古い状態」として扱われ、ダウンロードは
                  制限されます（PDF ファイル本体は保持されます）。
                  シーズン全体の組織／会社レポートも同様に再生成対象に
                  なります。
                </p>
                <p>
                  削除前に <b>retech@re-current.co.jp</b> /{' '}
                  <b>admin365@re-current.co.jp</b> に JSON
                  原文がバックアップメールとして送信されます。
                </p>
                <p>
                  続行するには、対象本人氏名「<b>{heroFullname}</b>
                  」を空白なしで入力してください。
                </p>
              </div>
            }
            style={{ marginBottom: 12 }}
          />
          <Input
            placeholder="対象本人氏名（lastname + name、空白なし）"
            onChange={(ev) => {
              inputEcho = ev.target.value;
            }}
            autoFocus
          />
        </div>
      ),
      okText: '削除実行',
      okButtonProps: { danger: true },
      cancelText: 'キャンセル',
      async onOk() {
        if (inputEcho.trim() !== heroFullname) {
          message.error({
            content: '本人氏名が一致しません',
            key: 'force',
            duration: 2,
          });
          // Promise.reject で Modal を閉じずに残す
          return Promise.reject();
        }
        const res = await forceMemberDeleteHandler(userInfo, heroFullname);
        if (res && res.data && res.data.success) {
          message.success({
            content: 'バックアップ送信後、データを削除しました',
            key: 'force',
            duration: 3,
          });
          // 既存 showConfirm のローカル状態更新ロジックと同等処理
          selSurveySeason.relation_360 = selSurveySeason.relation_360.map(
            (rel) => {
              if (rel._id === userInfo.teamId) {
                return {
                  ...rel,
                  [userInfo.relationName]: rel[userInfo.relationName].filter(
                    (id) => id !== userInfo.userId
                  ),
                };
              }
              return rel;
            }
          );
          const updatedTUsers = tUsers.map((u) => {
            if (u._id === userInfo.userId) {
              return {
                ...u,
                survey_token: u.survey_token.filter(
                  (t) => t._id !== userInfo.tokenId
                ),
              };
            }
            return u;
          });
          setTUsers(updatedTUsers);
          const gUserArr = [];
          selSurveySeason.relation_360.forEach((element) => {
            const found = updatedTUsers.find(
              (item) => item._id === element.user_id
            );
            if (found) gUserArr.push(found);
          });
          setGUsers(computCnt(visibleHeroes(gUserArr), selSurveySeasonId));
        } else {
          // サーバ側エラー（必須リレーションガード / バックアップメール失敗 等）
          // 失敗時はモーダルを閉じずに、ユーザーが対応後に再試行できるようにする
          message.error({
            content:
              (res && res.data && res.data.error) ||
              '強制削除に失敗しました',
            key: 'force',
            duration: 5,
          });
          return Promise.reject();
        }
      },
      onCancel() {
        // 通常キャンセル時はメッセージ不要
      },
    });
  };

  // C3 API 呼び出し
  const forceMemberDeleteHandler = async (userInfo, heroNameEcho) => {
    try {
      const info = {
        teamId: userInfo.teamId,
        userId: userInfo.userId,
        relationName: userInfo.relationName,
        seasonId: selSurveySeasonId,
        groupCode: selGroupCode,
        tokenId: userInfo.tokenId,
        confirm: 'YES_DELETE_WITH_ANSWERS',
        heroNameEcho,
        executorToken: localStorage.getItem('w_auth'),
      };
      const res = await Axios.patch(
        '/api/relation360/delmember/force',
        info
      );
      return res;
    } catch (error) {
      console.log(error);
      return error.response || null;
    }
  };

  //===========================================
  // 記述回答編集 (role 9 専用)
  // 対象チーム(hero)の提出済み協力者の自由記述(type20)回答を取得し、モーダルで編集する。
  // 不適切表現の是正や出力整形が目的。保存は各協力者の DbModel100 を直接更新し、
  // レポートは閲覧時に本回答から都度生成されるため次回生成から反映される。
  //===========================================
  const relationBucketLabel = { boss: '上司', partner: '同僚', sub: '部下・同僚' };

  const openDescriptiveEdit = async (record) => {
    try {
      setEditHeroName(
        ((record.lastname || '') + ' ' + (record.name || '')).trim()
      );
      setEditCollaborators([]);
      setEditModalOpen(true);
      setEditLoading(true);

      const team = (selSurveySeason.relation_360 || []).find(
        (t) => t.user_id === record._id
      );
      if (!team) {
        setEditLoading(false);
        return;
      }
      const buckets = [
        ['boss', team.boss || []],
        ['partner', team.partner || []],
        ['sub', team.sub || []],
      ];
      const targets = [];
      buckets.forEach(([bucket, ids]) => {
        ids.forEach((id) => {
          const u = tUsers.find((item) => item._id === id);
          if (!u || !u.survey_token) return;
          const token = u.survey_token.find(
            (ti) =>
              ti.survey_season_id === selSurveySeasonId &&
              ti.hero_id === record._id &&
              ti.survey_status === survey_status_complete
          );
          if (token) {
            targets.push({
              survey_token: token._id,
              name: (
                u.fullName || (u.lastname || '') + ' ' + (u.name || '')
              ).trim(),
              relationLabel: relationBucketLabel[bucket] || '協力者',
            });
          }
        });
      });

      // 各協力者の記述回答を取得（記述設問が1件以上ある協力者のみ表示）
      const collaborators = [];
      for (const t of targets) {
        const res = await Axios.get(
          `/api/dbModel100/${t.survey_token}/descriptive`
        );
        if (res.data.success) {
          const items = (res.data.items || []).map((it) => ({
            ...it,
            original: it.answer,
          }));
          if (items.length > 0) collaborators.push({ ...t, items });
        }
      }
      setEditCollaborators(collaborators);
    } catch (error) {
      console.log(error);
      message.error('記述回答の取得に失敗しました');
    } finally {
      setEditLoading(false);
    }
  };

  const onChangeEditText = (collaboratorIdx, itemIdx, value) => {
    setEditCollaborators((prev) =>
      prev.map((c, ci) =>
        ci === collaboratorIdx
          ? {
              ...c,
              items: c.items.map((it, ii) =>
                ii === itemIdx ? { ...it, answer: value } : it
              ),
            }
          : c
      )
    );
  };

  const saveDescriptiveEdit = async () => {
    try {
      setEditSaving(true);
      let savedCnt = 0;
      for (const c of editCollaborators) {
        const edits = {};
        c.items.forEach((it) => {
          if (it.answer !== it.original) edits[it.index] = it.answer;
        });
        if (Object.keys(edits).length === 0) continue;
        const res = await Axios.patch(
          `/api/dbModel100/${c.survey_token}/answers`,
          { edits }
        );
        if (res.data.success) savedCnt++;
      }
      message.success({
        content:
          savedCnt > 0
            ? `${savedCnt}名の記述回答を更新しました`
            : '変更はありませんでした',
        key: 'editDesc',
        duration: 2,
      });
      setEditModalOpen(false);
    } catch (error) {
      console.log(error);
      message.error('記述回答の保存に失敗しました');
    } finally {
      setEditSaving(false);
    }
  };

  //===========================================
  // チーム一括削除 (C4)
  // 計画書 Ph.3 — 本人 + 全協力者を一括削除。本人 PDF は ReportDoc + S3 ファイル
  // 本体ともに即時削除。シーズン組織/会社 PDF は集計影響により stale マーキング
  //===========================================
  const showTeamDeleteConfirm = async (heroRecord) => {
    const heroFullname =
      ((heroRecord.lastname || '') + (heroRecord.name || '')).trim();

    // 対象チーム情報（協力者人数・回答済人数の集計）
    const team = (selSurveySeason.relation_360 || []).find(
      (r) => r.user_id === heroRecord._id
    );
    const bossList = (team && team.boss) || [];
    const partnerList = (team && team.partner) || [];
    const subList = (team && team.sub) || [];
    const totalHelpers =
      bossList.length + partnerList.length + subList.length;

    // 回答済人数（hero_id 基準でカウント）
    let completedHelpers = 0;
    const memberIds = [...bossList, ...partnerList, ...subList];
    for (const mid of memberIds) {
      const u = tUsers.find((tu) => tu._id === mid);
      if (!u || !Array.isArray(u.survey_token)) continue;
      const tk = u.survey_token.find(
        (t) =>
          t.survey_season_id === selSurveySeasonId &&
          t.hero_id === heroRecord._id
      );
      if (tk && tk.survey_status === 5) completedHelpers++;
    }

    let inputEcho = '';
    Modal.confirm({
      title: 'チーム全体を削除します',
      width: 600,
      icon: null,
      content: (
        <div>
          <Alert
            type="error"
            showIcon
            message="この操作は取り消せません"
            description={
              <div>
                <p>
                  本人{' '}
                  <b>
                    {heroFullname}（{heroRecord.email}）
                  </b>{' '}
                  を中心とするチーム全体を削除します。
                </p>
                <p>
                  協力者 {totalHelpers} 名（上司 {bossList.length} 名 / 同僚{' '}
                  {partnerList.length} 名 / 部下 {subList.length} 名）、
                  うち回答済 {completedHelpers} 名。
                </p>
                <p>
                  対象本人の 360 度 PDF レポートは ReportDoc も S3
                  ファイル本体もすべて削除されます。シーズン全体の組織／会社
                  レポートは集計対象が変わるため再生成が必要となり、
                  「古い状態」として一時的にダウンロードが制限されます。
                </p>
                <p>
                  回答済データが存在する場合、削除前に{' '}
                  <b>retech@re-current.co.jp</b> /{' '}
                  <b>admin365@re-current.co.jp</b> に JSON
                  原文がバックアップメールとして送信されます。
                </p>
                <p>
                  続行するには、本人氏名「<b>{heroFullname}</b>
                  」を空白なしで入力してください。
                </p>
              </div>
            }
            style={{ marginBottom: 12 }}
          />
          <Input
            placeholder="本人氏名（lastname + name、空白なし）"
            onChange={(ev) => {
              inputEcho = ev.target.value;
            }}
            autoFocus
          />
        </div>
      ),
      okText: '削除実行',
      okButtonProps: { danger: true },
      cancelText: 'キャンセル',
      async onOk() {
        if (inputEcho.trim() !== heroFullname) {
          message.error({
            content: '本人氏名が一致しません',
            key: 'team',
            duration: 2,
          });
          return Promise.reject();
        }
        const res = await teamDeleteHandler(heroRecord, heroFullname);
        if (res && res.data && res.data.success) {
          message.success({
            content: 'チームを削除しました（バックアップ送信済み）',
            key: 'team',
            duration: 3,
          });
          // ローカル状態更新
          // 1) selSurveySeason.relation_360 から対象チーム除去
          selSurveySeason.relation_360 = (
            selSurveySeason.relation_360 || []
          ).filter((r) => r.user_id !== heroRecord._id);
          // 2) tUsers の各メンバーから当該シーズンのトークンを除去
          const affectedIds = [heroRecord._id, ...memberIds];
          const updatedTUsers = tUsers.map((u) => {
            if (!affectedIds.includes(u._id)) return u;
            return {
              ...u,
              survey_token: (u.survey_token || []).filter(
                (t) =>
                  !(
                    t.survey_season_id === selSurveySeasonId &&
                    t.hero_id === heroRecord._id
                  )
              ),
            };
          });
          setTUsers(updatedTUsers);
          // 3) gUsers から本人行を除去
          setGUsers((prev) =>
            (prev || []).filter((u) => u._id !== heroRecord._id)
          );
        } else {
          message.error({
            content:
              (res && res.data && res.data.error) ||
              'チーム削除に失敗しました',
            key: 'team',
            duration: 5,
          });
          return Promise.reject();
        }
      },
      onCancel() {
        // 通常キャンセル時はメッセージ不要
      },
    });
  };

  // C4 API 呼び出し
  // ※ DELETE+body はミドルボックスで body が削除される懸念があるため POST を採用
  const teamDeleteHandler = async (heroRecord, heroNameEcho) => {
    try {
      const info = {
        seasonId: selSurveySeasonId,
        userId: heroRecord._id,
        groupCode: selGroupCode,
        confirm: 'YES_DELETE_TEAM',
        heroNameEcho,
        executorToken: localStorage.getItem('w_auth'),
      };
      const res = await Axios.post(
        '/api/relation360/team/delete',
        info
      );
      return res;
    } catch (error) {
      console.log(error);
      return error.response || null;
    }
  };

  const getSubjectToken = (subject) =>
    (Array.isArray(subject.survey_token) ? subject.survey_token : []).find(
      (token) =>
        token.relation === 1 && token.survey_season_id === selSurveySeasonId
    );

  const showConfirm2 = async (userInfo, type) => {
    confirm({
      title: 'サーベイ結果を生成しますか？',
      content:
        'サーベイ結果を生成し別TabでPDF表示します。このままお待ちください。',
      async onOk() {
        setIsModalVisible(true);
        // console.log({ userInfo });
        let tokenI = getSubjectToken(userInfo);
        tokenI.type = type;
        tokenI.group_name = selGroupInfo.group_name;
        tokenI.training_start_date = selSurveySeason.training_start_date;
        tokenI.training_end_date = selSurveySeason.training_end_date;
        tokenI.survey_start_date = selSurveySeason.survey_start_date;
        tokenI.survey_end_date = selSurveySeason.survey_end_date;
        tokenI.user_name = `${userInfo.lastname} ${userInfo.name}`;
        if (userInfo.lastSeason) {
          tokenI.lastSeasonTokenInfo = userInfo.lastSeasonTokenInfo;
          tokenI.lastSurveySeason = userInfo.lastSurveySeason;
        }
        let dep = '';
        if (userInfo.department) dep = userInfo.department;
        if (userInfo.department2) dep = dep + ' ' + userInfo.department2;
        if (userInfo.department3) dep = dep + ' ' + userInfo.department3;
        if (userInfo.department4) dep = dep + ' ' + userInfo.department4;
        if (userInfo.department5) dep = dep + ' ' + userInfo.department5;
        tokenI.department = dep;
        tokenI.tName = selSurveySeason.t_name;
        tokenI.name_360 = selSurveySeason.name_360;
        tokenI.relationInfo = selSurveySeason.relation_360.find(
          (item) => item.user_id === userInfo._id
        );
        tokenI.type_360 = selSurveySeason.question_set[0].type_360;
        // console.log({ tokenI });
        const result = await Axios.post(
          '/api/dbModel100/makeReport40010',
          tokenI
        );
        // console.log({ result });
        if (result.data.success) {
          // if (0) {
          // message.success('結果生成が完了しました。マイ・サーベイに戻ります。');
          // props.history.push('/mysurvey');
          // サーバープロキシ経由でPDFを表示（S3 URLを露出しない）
          message.success({
            content: 'ファイル生成完了！',
            key: 'makecsv',
            duration: 2,
          });
          setIsModalVisible(false);
          openReport(result.data.tokenId);
        } else {
          setIsModalVisible(false);
          console.log('結果生成で問題が発生しました。');
          message.error('結果生成で問題が発生しました。');
        }
      },
      async onCancel() {},
    });
  };

  // テーブル強化 PJ Ph.3: メイン一覧テーブルの <Column> → columns 配列。
  // expandable（展開列）があるため reservedWidth で幅を予約。rowClassName（行ティント）・
  // bordered・expandedRowRender は維持。テキスト列はソート + 省略、操作列は既存ボタンを維持。
  const rawColumns = [
    ellipsisColumn({
      title: '名前',
      dataIndex: 'fullName',
      key: 'fullName',
      width: 140,
      sorter: textSorter('fullName'),
      //検索に一致した本人(hero)の行のみ、検索語に当たった部分文字列だけをハイライト
      render: (value, record) =>
        heroMatchIds.has(record._id)
          ? highlightMatch(value, searchKeyword.trim(), true)
          : value,
    }),
    ellipsisColumn({
      title: 'メール',
      dataIndex: 'email',
      key: 'email',
      width: 200,
      sorter: textSorter('email'),
      //同上（メールは空白無視をしない）
      render: (value, record) =>
        heroMatchIds.has(record._id)
          ? highlightMatch(value, searchKeyword.trim(), false)
          : value,
    }),
    ellipsisColumn({
      title: '会社',
      dataIndex: 'company',
      key: 'company',
      width: 150,
      sorter: textSorter('company'),
    }),
    ellipsisColumn({
      title: '部署',
      dataIndex: 'department',
      key: 'department',
      width: 130,
      sorter: textSorter('department'),
    }),
    {
      title: '回答状態',
      key: 'status',
      width: 110,
      sorter: (a, b) => (a.status ? 1 : 0) - (b.status ? 1 : 0),
      // dataIndex なしのため render 第 1 引数は record（rc-table 仕様・従来通り）
      render: (record) =>
        record.status ? (
          <span>
            <Badge status="success" />
            回答済
          </span>
        ) : (
          <span>
            <Badge status="error" />
            未回答
          </span>
        ),
    },
    {
      title: '回答日',
      dataIndex: 'testDate',
      key: 'testDate',
      width: 120,
      sorter: textSorter('testDate'),
    },
    {
      title: '回答済 / 全体 ： 基準',
      dataIndex: 'cnt',
      key: 'cnt',
      width: 160,
      sorter: textSorter('cnt'),
    },
    {
      // ★暫定（2026-10-27）: Web 結果の導線は特権管理者だけ。それ以外は従来の表示（surveyMeta.js の isWeb360OpenFor）
      title: isWeb360OpenFor(userInfo.role)
        ? '診断結果'
        : '診断結果ダウンロード',
      key: 'result',
      width: 300,
      render: (text, record) => {
        if (!isWeb360OpenFor(userInfo.role)) {
          return (
            <span>
              {selSurveySeason.survey_code === '60020' ? (
                <Space>
                  <Button
                    type="primary"
                    size="small"
                    onClick={(e) => showConfirm2(record, 1)}
                    disabled={!record.totalStatus}
                  >
                    結果確認
                  </Button>
                </Space>
              ) : selSurveySeason.question_set[0].type_360 === '3x3x5' ||
                selSurveySeason.question_set[0].type_360 === 'gates' ||
                selSurveySeason.question_set[0].type_360 === 'initiative' ||
                selSurveySeason.question_set[0].type_360 === 'eleader' ? (
                <Space>
                  <Button
                    type="primary"
                    size="small"
                    onClick={(e) => showConfirm2(record, 1)}
                    disabled={!record.totalStatus}
                  >
                    結果確認
                  </Button>
                </Space>
              ) : (
                <Space>
                  <Button
                    type="primary"
                    size="small"
                    onClick={(e) => showConfirm2(record, 1)}
                    disabled={!record.totalStatus}
                  >
                    個人用
                  </Button>
                  <Button
                    size="small"
                    onClick={(e) => showConfirm2(record, 2)}
                    disabled={!record.totalStatus}
                  >
                    共有用
                  </Button>
                  <Button
                    size="small"
                    onClick={(e) => showConfirm2(record, 3)}
                    disabled={!record.totalStatus || !record.lastSeason}
                  >
                    比較表
                  </Button>
                </Space>
              )}
            </span>
          );
        }
        const subjectToken = getSubjectToken(record);
        const type360 = selSurveySeason.question_set?.[0]?.type_360;
        const webResultAvailable =
          (selSurveySeason.survey_code === '60020' &&
            ['bsfs', 'bsfs_basic'].includes(type360)) ||
          (selSurveySeason.survey_code === '40010' &&
            WEB_RESULT_40010_TYPES.includes(type360));
        const traditionalWebResult =
          selSurveySeason.survey_code === '40010' &&
          TRADITIONAL_40010_TYPES.includes(type360);
        const webResultUrl = subjectToken
          ? `/results/${selSurveySeason.survey_code}/${encodeURIComponent(
              subjectToken._id
            )}?view=admin`
          : undefined;

        return (
          <span>
            {selSurveySeason.survey_code === '60020' ||
            webResultAvailable ? (
              <Space wrap>
                {webResultAvailable && (
                  <Button
                    type="primary"
                    size="small"
                    href={webResultUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    disabled={!record.totalStatus || !subjectToken}
                  >
                    Webで見る
                  </Button>
                )}
                <Button
                  size="small"
                  onClick={(e) => showConfirm2(record, 1)}
                  disabled={!record.totalStatus}
                >
                  {traditionalWebResult
                    ? '個人用'
                    : webResultAvailable
                    ? 'PDFを開く'
                    : '結果確認'}
                </Button>
                {traditionalWebResult && (
                  <>
                    <Button
                      size="small"
                      onClick={(e) => showConfirm2(record, 2)}
                      disabled={!record.totalStatus}
                    >
                      共有用
                    </Button>
                    <Button
                      size="small"
                      onClick={(e) => showConfirm2(record, 3)}
                      disabled={!record.totalStatus || !record.lastSeason}
                    >
                      比較表
                    </Button>
                  </>
                )}
              </Space>
            ) : (
              <Space>
                <Button
                  type="primary"
                  size="small"
                  onClick={(e) => showConfirm2(record, 1)}
                  disabled={!record.totalStatus}
                >
                  個人用
                </Button>
                <Button
                  size="small"
                  onClick={(e) => showConfirm2(record, 2)}
                  disabled={!record.totalStatus}
                >
                  共有用
                </Button>
                <Button
                  size="small"
                  onClick={(e) => showConfirm2(record, 3)}
                  disabled={!record.totalStatus || !record.lastSeason}
                >
                  比較表
                </Button>
              </Space>
            )}
          </span>
        );
      },
    },
    ...(userInfo.role === 9
      ? [
          {
            title: '記述編集',
            key: 'descEdit',
            width: 120,
            align: 'center',
            render: (text, record) => (
              <Button
                size="small"
                onClick={() => openDescriptiveEdit(record)}
              >
                記述回答編集
              </Button>
            ),
          },
          {
            title: 'チーム削除',
            key: 'teamDelete',
            width: 120,
            align: 'center',
            render: (text, record) => (
              <Button
                danger
                size="small"
                onClick={() => showTeamDeleteConfirm(record)}
              >
                チーム削除
              </Button>
            ),
          },
        ]
      : []),
  ];

  const { columns, components, scroll, wrapRef } = useResizableColumns(
    rawColumns,
    { reservedWidth: 48 }
  );

  return (
    <Fragment>
      <PageContainer fluid>
        <div style={{ marginTop: 16, marginBottom: 16 }}>
          <Text>■絞り込み｜</Text>
          {(userInfo.role === 9 || userInfo.role === 2) && (
            <>
              <Text>企業選択</Text>
              <Select
                showSearch
                style={{
                  marginBottom: 10,
                  marginLeft: 5,
                  marginRight: 5,
                  width: 200,
                }}
                placeholder="企業選択"
                optionFilterProp="children"
                onChange={onChangeGroup}
                value={selGroupCode}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                disabled={userInfo.role === 3 || userInfo.role === 7}
              >
                {groups.map((element) => {
                  // console.log({ element });
                  return (
                    <Option value={element.group_code} key={element._id}>
                      {element.group_name}
                    </Option>
                  );
                })}
              </Select>
            </>
          )}
          {selGroupInfo.survey_season && (
            <Fragment>
              サーベイシーズン選択:
              <Select
                showSearch
                allowClear
                style={{
                  marginBottom: 10,
                  marginLeft: 5,
                  marginRight: 5,
                  width: 400,
                }}
                placeholder="シーズン選択"
                optionFilterProp="children"
                onChange={onChangeSeasonFilter}
                value={selSurveySeasonId || undefined}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {filterAccessibleSeasons(selGroupInfo.survey_season, usr.userData).map((element) => {
                  if (
                    element.survey_code === '40010' ||
                    element.survey_code === '60020'
                  ) {
                    //360診断のみシーズン選択可能
                    return (
                      <Option value={element._id} key={element._id}>
                        {element.season_name}
                      </Option>
                    );
                  }
                })}
              </Select>
            </Fragment>
          )}
          {selSurveySeasonId && (
            <Fragment>
              <Input
                allowClear
                prefix={<SearchOutlined style={{ color: 'var(--grey-45)' }} />}
                placeholder="氏名またはメールで検索"
                style={{
                  width: 300,
                  marginLeft: 5,
                  marginRight: 8,
                  marginBottom: 10,
                }}
                value={searchKeyword}
                onChange={onChangeSearchKeyword}
              />
              {searchKeyword.trim() && (
                <Text style={{ color: 'var(--orange-active)' }}>
                  一致 {teamCount}チーム・{personCount}名
                </Text>
              )}
            </Fragment>
          )}
          {selGroupCode && !selGroupInfo.survey_season && (
            <Text type="danger" style={{ display: 'block', marginTop: 6 }}>
              このグループには多面評価・診断（360度／FS）のサーベイシーズンがありません。
            </Text>
          )}
          {selGroupCode &&
            selGroupInfo.survey_season &&
            filterAccessibleSeasons(selGroupInfo.survey_season, usr.userData)
              .length === 0 && (
              <Text type="danger" style={{ display: 'block', marginTop: 6 }}>
                {noAccessibleSeasonMessage(usr.userData)}
              </Text>
            )}
          <br />
        </div>
        {/* item 18.4: 列タイトル（ヘッダー）の cream 塗り + 上下線は 2 次トラック S3-b で
            全テーブルへグローバル昇格したため個別 className は撤去（ネスト協力者テーブルも自動で適用）。 */}
        <div ref={wrapRef}>
          <Table
            columns={columns}
            components={components}
            scroll={scroll}
            dataSource={filteredUsers}
            size="middle"
            rowKey="_id"
            pagination={{
              current: currentPage,
              pageSize,
              showSizeChanger: true,
              pageSizeOptions: ['50', '100', '200', '500'],
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} / ${total}件`,
              onChange: (page, size) => {
                setCurrentPage(page);
                setPageSize(size);
              },
            }}
            rowClassName={(record) =>
              (record.totalStatus ? 'main360-ok' : 'main360') +
              (heroMatchIds.has(record._id) ? ' search360-hit' : '')
            }
            expandable={{
              expandedRowRender,
              expandedRowKeys,
              onExpandedRowsChange: (keys) => setExpandedRowKeys(keys),
            }}
            bordered
          />
        </div>
      </PageContainer>
      <Modal
        title="サーベイ結果ファイル生成中..."
        open={isModalVisible}
        okButtonProps={{ disabled: true }}
        cancelButtonProps={{ disabled: true }}
        styles={{ body: { textAlign: 'center' } }}
      >
        <Spin size="large" />
      </Modal>
      <Modal
        title="協力者を追加"
        open={addModalOpen}
        confirmLoading={addLoading}
        okText="追加"
        cancelText="キャンセル"
        onOk={addMemberHandler}
        onCancel={() => setAddModalOpen(false)}
      >
        <div style={{ marginBottom: 'var(--space-4)' }}>
          <Text strong style={{ display: 'block', marginBottom: 'var(--space-2)' }}>
            関係（必須）
          </Text>
          <Select
            style={{ width: '100%' }}
            value={addRelationName}
            onChange={(v) => setAddRelationName(v)}
            options={[
              { value: 'boss', label: '上司' },
              { value: 'partner', label: '同僚' },
              { value: 'sub', label: '部下' },
            ]}
          />
        </div>
        <div>
          <Text strong style={{ display: 'block', marginBottom: 'var(--space-2)' }}>
            追加する人（同じ企業の中から氏名・メールで検索・必須）
          </Text>
          <Select
            showSearch
            style={{ width: '100%' }}
            placeholder="氏名またはメールで検索"
            value={addUserId}
            onChange={(v) => setAddUserId(v)}
            options={getAddCandidates()}
            optionFilterProp="label"
            filterOption={(input, option) =>
              (option?.label || '').toLowerCase().includes(input.toLowerCase())
            }
          />
        </div>
      </Modal>
      {/* 記述回答編集モーダル (role 9 専用) */}
      <Modal
        title={`記述回答編集：${editHeroName} さんチーム`}
        open={editModalOpen}
        width={820}
        okText="保存"
        cancelText="キャンセル"
        confirmLoading={editSaving}
        onOk={saveDescriptiveEdit}
        onCancel={() => setEditModalOpen(false)}
        okButtonProps={{ disabled: editLoading }}
      >
        <Alert
          type="info"
          showIcon
          style={{ marginBottom: 'var(--space-4)' }}
          message="協力者が入力した自由記述の回答を編集できます。保存後、次回のレポート生成から反映されます。"
        />
        {editLoading ? (
          <div style={{ textAlign: 'center', padding: 'var(--space-6)' }}>
            <Spin size="large" />
          </div>
        ) : editCollaborators.length === 0 ? (
          <Text>編集可能な記述回答がありません。</Text>
        ) : (
          editCollaborators.map((c, ci) => (
            <div
              key={c.survey_token}
              style={{ marginBottom: 'var(--space-5)' }}
            >
              <Text strong>
                {c.name}（{c.relationLabel}）
              </Text>
              {c.items.map((it, ii) => (
                <div
                  key={it.index}
                  style={{ marginTop: 'var(--space-2)' }}
                >
                  <Text type="secondary" style={{ fontSize: '13px' }}>
                    {it.no}. {it.question}
                  </Text>
                  <TextArea
                    rows={3}
                    value={it.answer}
                    onChange={(e) =>
                      onChangeEditText(ci, ii, e.target.value)
                    }
                  />
                </div>
              ))}
            </div>
          ))
        )}
      </Modal>
    </Fragment>
  );
}

export default Status360Page;
